import { RouteConfig } from '../types';
import { ONBOARDING_KEYS } from '../constants';
import { HELP_CENTER_LINKS } from '../helpCenterLinks';

export const teamsPageSteps = [
  {
    element: '[data-onboarding="teams-page"]',
    popover: {
      title: 'Teams Dashboard',
      description:
        `View all monitoring <a href="${HELP_CENTER_LINKS.teams}" target="_blank" class="text-lime underline">teams</a> in your organisation. Search, add teams, and manage team members.`,
      side: 'bottom' as const,
      align: 'start' as const,
    },
  },
  {
    element: '[data-onboarding="teams-add-button"]',
    popover: {
      title: 'Add New Team',
      description:
        'Create a new monitoring team. Enter the team name and primary email in the form provided.',
      side: 'left' as const,
      align: 'start' as const,
    },
  },
  {
    element: '[data-onboarding="teams-utility-bar"]',
    popover: {
      title: 'Search and Filter Tools',
      description:
        'Use the search bar to find teams by name or email. Customize your view with column visibility and open the filters panel to narrow the team list.',
      side: 'bottom' as const,
      align: 'center' as const,
    },
  },
  {
    element: '[data-onboarding="teams-table"] table tbody, [data-onboarding="teams-table"] table',
    popover: {
      title: 'Teams Table',
      description:
        'All monitoring teams are listed with details such as name, primary email, and default status. Click a team to view its details and manage members.',
      side: 'top' as const,
      align: 'start' as const,
    },
  },
];

export const addTeamSteps = [
  {
    element: '[data-onboarding="add-team-form"]',
    popover: {
      title: 'Add New Monitoring Team',
      description:
        'Enter the team name and primary email to create a new team. The email domain is extracted automatically. Select Create Team to save.',
      side: 'left' as const,
      align: 'start' as const,
    },
  },
];

export const teamDetailSteps = [
  {
    element: '[data-onboarding="team-detail-header"]',
    popover: {
      title: 'Team Details',
      description:
        'The team name and contact email are shown here. Select Save to apply changes, or Cancel to discard them.',
      side: 'bottom' as const,
      align: 'start' as const,
    },
  },
  {
    element: '[data-onboarding="team-detail-tabs"]',
    popover: {
      title: 'Navigation Tabs',
      description:
        'Switch between Team Details, Team Members, and Recent Shifts to view and manage different aspects of this team.',
      side: 'bottom' as const,
      align: 'start' as const,
    },
  },
  {
    element: '[data-onboarding="team-detail-info"]',
    popover: {
      title: 'Basic Information',
      description:
        'View and edit the team profile, including team name, contact email, default status, and priority order.',
      side: 'left' as const,
      align: 'start' as const,
    },
  },
];

export const teamRoutes: RouteConfig[] = [
  {
    id: 'teams',
    processName: ONBOARDING_KEYS.teams,
    match: (path: string) => path === '/team',
    steps: teamsPageSteps,
  },
  {
    id: 'add-team',
    processName: ONBOARDING_KEYS.addTeam,
    match: (path: string) => path === '/team/add',
    steps: addTeamSteps,
  },
  {
    id: 'team-detail',
    processName: ONBOARDING_KEYS.teamDetail,
    match: (path: string) => /^\/tenant\/[^/]+\/team\/[^/]+$/.test(path),
    steps: teamDetailSteps,
  },
];
